export const metadataSubscriptionAssignmentKeyPrefix = 'assignedTo'
